import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ClientDashboard from "./pages/client/ClientDashboard";
import CoordinatorDashboard from "./pages/coordinator/CoordinatorDashboard";
import CorporatecoordinatorDashboard from "./pages/corporatecoordinator/CorporatecoordinatorDashboard";
import ECGDashboard from "./pages/Ecg_dashboard/Ecg_dashboard";
import ECGPatientDashboard from "./pages/Ecg_dashboard/Ecg_client_dashboard";
import ECGPDFDashboard from "./pages/Ecg_dashboard/Ecg_pdf_dashboard";  
import SuperCoordinatorPanel from "./pages/superCoordinator/SuperCoordinatorPanel";
import PatientRecordsSearch from "./pages/superCoordinator/PatientRecordsSearch";
import DoctorDashboard from './pages/doctor/DoctorDashboard';
import Viewer from './pages/doctor/Viewer';
import LoginPage from './pages/login/LoginPage';
import Doctorstatus from './pages/doctorstatus/doctorstatus';
import CorporateDoctorstatus from './pages/doctorstatus/corporatedoctorstatus';
import LogoutPage from './pages/logout/LogoutPage';
import CardiologistDashboard from './pages/Ecg_dashboard/Ecg_reporting_dashboard';
import PatientReportPage from './pages/Ecg_dashboard/Ecg_report';
import Reviewer from './pages/Reviewer/Reviewer';
import ECGReportsPage from './pages/Ecg_dashboard/Ecg_clientpdf';
import PdfPage  from './pages/coordinator/pdfpage/PdfPage';
import Report from './pages/client/Report'; 
import AutoAssings from './pages/superCoordinator/Auto_assing';
import ClinetViwer from './pages/client/ClinetViwer';
import DicomsUploader from './pages/client/Dicomuploader';
import CoordinatorChat from './pages/chat/CoordinatorChat'
import ReportViewer from './pages/Reviewer/Reviewerviwer';
import MedicalTranslationRules from "./pages/superCoordinator/medical_hindi";
import AccountDashboard from './pages/account/AccountDashboard';
import ECGVendorDashboard from './pages/alivecor_ecg/ECGVendorDashboard';
import ECGReports from './pages/alivecor_ecg/alivecor_reports/ecg_vendor_reports';

// ✅ Component to handle refresh on browser back/forward
function ForceRefreshOnBack() {
  const location = useLocation();

  useEffect(() => {
    window.onpopstate = () => {
      window.location.reload();
    };

    return () => {
      window.onpopstate = null;
    };
  }, [location]);

  return null;
}

function App() {
 useEffect(() => {

    // ✅ Ping server every 1 minute
    const interval = setInterval(() => {

      fetch("https://backend.reportingbot.in/api/ping/", {
        method: "GET",
        credentials: "include",
      })
      .catch((err) => console.log(err));

    }, 60000);

    // ✅ Logout when browser/tab closes
    // const handleUnload = () => {

    //   navigator.sendBeacon(
    //     "https://backend.reportingbot.in/api/logout/"
    //   );

    // };

    // window.addEventListener(
    //   "beforeunload",
    //   handleUnload
    // );

    return () => {

      clearInterval(interval);

      // window.removeEventListener(
      //   "beforeunload",
      //   handleUnload
      // );

    };

  }, []);

  return (
    <Router>
      {/* 🔹 Add it once here */}
      <ForceRefreshOnBack />

      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/doctor-dashboard" element={<DoctorDashboard />} />
        <Route path="/dicom-uploader" element={<DicomsUploader />} />
        <Route path="/viewer" element={<Viewer />} />
        <Route path="/doctor-status" element={<Doctorstatus />} />
        <Route path="/corporate-doctor-status" element={<CorporateDoctorstatus />} />
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/client-dashboard" element={<ClientDashboard />} />
        <Route path="/coordinator" element={<CoordinatorDashboard />} />
        <Route path="/corporatecoordinator" element={<CorporatecoordinatorDashboard />} />
        <Route path="/superCoordinator" element={<SuperCoordinatorPanel/>} />
        <Route path="/ecg-dashboard" element={<ECGDashboard />} />
        <Route path="/ecg-patient-dashboard" element={<ECGPatientDashboard />} />
        <Route path="/ecg-pdf-dashboard" element={<ECGPDFDashboard />} />
        <Route path="/SuperCoordinator" element={<SuperCoordinatorPanel />} />
        <Route path="/PatientRecordsSearch" element={<PatientRecordsSearch />} />
        {/* <Route path="*" element={<LoginPage />} /> */}
        <Route path="/cardiologist-dashboard" element={<CardiologistDashboard />} />
        <Route path="/ecg-report/:patientId" element={<PatientReportPage />} />
        <Route path="/reviewer" element={<Reviewer  />} />
        <Route path="/ecg-report" element={<ECGReportsPage />} />
        <Route path="/xrai-allocation" element={<PdfPage />} />
        <Route path="/report-Page" element={<Report />} />
        <Route path="/auto-assign" element={<AutoAssings />} /> 
         <Route path="/clientviwer" element={<ClinetViwer />} /> 
         <Route path="/coordinator/live-chat" element={<CoordinatorChat />}/>
          <Route path="/Reviewerviwer" element={<ReportViewer />} />
        <Route path="/medical-translation-rules" element={<MedicalTranslationRules />} />
        <Route path="/account-dashboard" element={<AccountDashboard />} />
        <Route path="/ecg-vendor-dashboard" element={<ECGVendorDashboard />} />
        <Route path="/ecg-vendors-reports" element={<ECGReports />} />
      </Routes>
    </Router>
  );
}

export default App;
